import type { CookieConsentTranslations } from "./pl";

export const en: CookieConsentTranslations = {
  ariaLabel: "Cookie consent",
  title: "Cookies and privacy",
  defaultText:
    "We use cookies to make the site work properly and - with your consent - for analytics and marketing. You can accept all, reject optional ones or customise your choice.",
  acceptAll: "Accept all",
  rejectAll: "Reject optional",
  customize: "Customise",
  settingsTitle: "Cookie settings",
  alwaysActive: "Always active",
  back: "Back",
  savePreferences: "Save choice",
  cookiesLabel: "Cookies",
  manageButton: "Cookie settings",
  close: "Close",
  showCookies: "Show cookies",
  hideCookies: "Hide cookies",
  cookieHost: "Host",
  cookieDuration: "Duration",
  cookieDescription: "Description",
};
